import { isEditMode } from 'pro-gallery-lib';
class MediaScrollHelper {
    constructor(config) {
        this.config = config;
        this.scrollHelpers = [];
        this.stop = (idx) => {
            for (const scrollHelper of this.scrollHelpers) {
                if (scrollHelper.findItem(idx)) {
                    scrollHelper.stop(idx);
                }
            }
        };
        this.initializePlayState = () => {
            for (const scrollHelper of this.scrollHelpers) {
                scrollHelper.initializePlayState();
            }
        };
        this.onScroll = ({ top, left }) => {
            if (!this.scrollHelpers.length) {
                this.top = top || this.top;
                this.left = left || this.left;
            }
            for (const scrollHelper of this.scrollHelpers) {
                scrollHelper.onScroll({ top, left });
            }
        };
        this.handleEvent = (event) => {
            for (const scrollHelper of this.scrollHelpers) {
                scrollHelper.handleEvent(event);
            }
        };
        this.updateGalleryStructure = (data) => {
            if (data.isSSR) {
                //TODO - This could be broken in hydrate since we use inPrerenderMode. (diff between hydrate and ssr are breaking)
                return;
            }
            for (const scrollHelper of this.scrollHelpers) {
                scrollHelper.updateGalleryStructure(data);
            }
            if (this.scrollHelperPromise) {
                this.latestGalleryStructure = data;
                return;
            }
            this.latestGalleryStructure = data;
            if (isEditMode()) {
                return;
            }
            if (!data.galleryStructure.galleryItems.some((item) => this.config.some((c) => c.supportedItemsFilter(item)))) {
                return;
            }
            this.scrollHelperPromise = import(/* webpackChunkName: "proGallery_videoScrollHelper" */ './mediaScrollHelper.js')
                .then(({ default: VideoScrollHelper }) => {
                for (const config of this.config) {
                    this.scrollHelpers.push(
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    new VideoScrollHelper(config.onSetPlayingIdx, config.supportedItemsFilter, config.getPlayTrigger));
                }
                this.updateGalleryStructure(this.latestGalleryStructure);
                this.onScroll({ top: this.top, left: this.left });
            })
                .catch((e) => {
                console.error('Failed to load videoScrollHelper. error: ' + e);
            });
        };
        this.left = 0;
        this.top = 0;
    }
}
export default MediaScrollHelper;
//# sourceMappingURL=mediaScrollHelperWrapper.js.map